var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144 0c8.8 0 16 7.2 16 16V64H352V16c0-8.8 7.2-16 16-16s16 7.2 16 16V64h32c35.3 0 64 28.7 64 64v32 32V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V192 160 128c0-35.3 28.7-64 64-64h32V16c0-8.8 7.2-16 16-16zM448 192H64V448c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V192zM416 96H96c-17.7 0-32 14.3-32 32v32H448V128c0-17.7-14.3-32-32-32zM327.6 257.9c-6.2-6.2-16.4-6.2-22.6 0l-12.2 12.2 29.1 29.1L334.1 287c6.2-6.2 6.2-16.4 0-22.6l-6.4-6.4zm-28.4 63.9l-29.1-29.1L182 381l-8.6 37.7L211 410l88.2-88.2zm-16.9-86.5c18.7-18.7 49.1-18.7 67.9 0l6.4 6.4c18.7 18.7 18.7 49.1 0 67.9l-123 123c-4.3 4.3-9.6 7.2-15.5 8.6L168 452.7c-17.3 4-32.7-11.5-28.8-28.8l11.5-50.2c1.3-5.9 4.3-11.2 8.6-15.5l123-123z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarPen);
export default __webpack_public_path__ + "static/media/calendar-pen.d58b835b70bfe9f7bca218319aabd86e.svg";
export { ForwardRef as ReactComponent };